package feature.mediaFile.viewModel

//import kotlinx.coroutines.IO
import feature.app.AppViewModel
import feature.business.handler.BusinessHandler
import feature.mediaFile.handler.MediaFileHandler
import feature.mediaFile.model.MediaFile
import feature.mediaFile.network.MediaFileNetwork
import feature.mediaFile.network.MediaFileRetrieveRequest
import feature.mediaFile.repository.MediaFileRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class MediaFileViewModel(private val repository: MediaFileRepository = MediaFileHandler.shared().repository) :
    AppViewModel() {

    private var job: Job = Job()

    val allData: StateFlow<List<MediaFile>>
        get() = repository.allLiveData

    val selectedData: StateFlow<MediaFile>
        get() = repository.selected

    val mediaFiles: StateFlow<List<MediaFile>>
        get() = repository.mediaFiles

    val mediaFileLiveData: MutableStateFlow<MediaFile> = MutableStateFlow(MediaFile())
    val mediaFile: StateFlow<MediaFile>
        get() = mediaFileLiveData

    fun loadFor(featureObjectID: String, completion: (ArrayList<MediaFile>) -> Unit) {
//        scope.launch {
//            val mediaFiles = DatabaseHandler.shared().database.mediaFileDao().itemFor(featureObjectID)
//            if(mediaFiles.isNotEmpty()){
//                completion(mediaFiles as ArrayList<MediaFile>)
//            }else{
//                retrieveFor(featureObjectID)
//            }
//        }
    }

    fun find(featureObjectID: String): String {
        var stringToReturn = ""
        allData.value.forEach { item ->
            if (item.FeatureObjectID == featureObjectID && !item.FileURL.isNullOrEmpty()) {
                stringToReturn = item.FileURL!!
            }
        }
        return stringToReturn
    }

    fun loadMedia(id: String) {
        if (allData.value.isNotEmpty()) {
            allData.value.forEach {
                if (it.FeatureObjectID == id) {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        mediaFileLiveData.emit(it)
                    }
                }
            }
        } else {
            retrieveFor(id)
        }
    }

    //    fun uploadImage(fileUri: Uri?,featureObjectID:String){
//        if (fileUri != null) {
//            val unixTime = System.currentTimeMillis()
//            val fileName = "$unixTime.png"
//            val imageRef = repository.storageBucketReferece?.child(fileName)
//            imageRef?.putFile(fileUri!!)?.addOnSuccessListener { taskSnapshot ->
//                taskSnapshot.storage.downloadUrl.addOnSuccessListener {
//                    MediaFileHandler.shared().onCreateNew={
//                        this.activity?.runOnUiThread  {
//                            this.activity?.toast("Image Updated Successfully")
//                        }
//                    }
//                    val imageUrl = it.toString()
//                    updateMediaFileInServer(featureObjectID,imageUrl)
//                }
//            }?.addOnFailureListener { e ->
//                print(e.message)
//                this.activity?.runOnUiThread {
//                    activity?.toast("Oops! Failed to upload image at the moment")
//                }
//            }
//        }else{
//            activity?.onBackPressed()
//        }
//    }
//
//
//    fun updateMediaFileInServer(featureObjectID: String, image: String) {
//        val user = FriendlyUser()
//        val request = JSONObject()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.businessID, business.value?.Id)
//        request.put(KeyConstant.fileURL, image)
//        request.put(KeyConstant.userId, user._id)
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.featureObjectID, featureObjectID)
//        MediaFileHandler.shared().viewModel?.createNew(request)
//    }
//
//    fun retrieveFor(featureObjectID:String){
//        val request = JSONObject()
//        val user = FriendlyUser()
//        val business = BusinessHandler.shared().repository.business
//        request.put(KeyConstant.userId,user._id)
//        if(!business.value?.Id.isNullOrEmpty()){
//            request.put(KeyConstant.businessID, business.value?.Id)
//        }
//        request.put(KeyConstant.deviceId, AuthHandler.shared().deviceId)
//        request.put(KeyConstant.featureObjectID,featureObjectID)
//        MediaFileNetwork.shared().retrieve(request){ payload->
//            var allObj : ArrayList<MediaFile> = arrayListOf()
//            if(payload != null){
//                for (i in 0 until payload!!.length())
//                {
//                    val item = payload?.getJSONObject(i)
//                    val modelObject = Gson().fromJson(item.toString(), MediaFile::class.java)
//                    allObj.add(modelObject)
//                    insert(modelObject)
//                }
//            }
//            repository.liveData.postValue(allObj)
//        }
//    }
//
    fun retrieveFor(id: String, completion: ((MediaFile) -> Unit) = {}) {
        val business = BusinessHandler.shared().repository.business
        if (business.value.Id.isEmpty()) {
            return
        }
        val request = MediaFileRetrieveRequest(business.value.Id, id)
        MediaFileNetwork().retrieve(request) {
            if (!it?.payload.isNullOrEmpty()) {
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    mediaFileLiveData.emit(it!!.payload.first())
                    completion(it.payload.first())
                }
            }
        }
    }

    fun retrieve(completion: (() -> Unit) = {}) {
        val business = BusinessHandler.shared().repository.business
        if (business.value.Id.isEmpty()) {
            return
        }
        val request = MediaFileRetrieveRequest(business.value.Id)
        MediaFileNetwork().retrieve(request) {
            if (!it?.payload.isNullOrEmpty()) {
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    repository.liveData.emit(it!!.payload)
                }
            }
        }
    }
//
//    fun createNew(request:JSONObject) {
//        val unixTime = System.currentTimeMillis()
//        request.put(KeyConstant.uniqueId,unixTime)
//        SocketService.shared().send(MediaFileEvent.CREATE, request)
//    }
//
//    fun insert(newData : MediaFile){
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.mediaFileDao().insert(newData)
//        }
//    }
}